export enum ConnectionState
{
    NEW = "New",
    AVAILABLE = "Available",
    UNAVAILABLE = "Unavailable",
    ARCHIVED = "Archived"
    
}